import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authContext = useContext(AuthContext);

  if (authContext?.loading) {
    return <div>Loading...</div>;
  }

  return authContext?.user ? <>{children}</> : <Navigate to="/auth" />;
};

export default PrivateRoute; 